import { useState } from "react";
import { useAuthHeader, useAuthUser } from "../../../Services/Auth/sessionAuth";
import { Button, Form, Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { TeamOutlined, SearchOutlined, UndoOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import { Crypter } from "../../../Functions/Security/Crypter";
import Data from '../../../Data/Data.json';
import axios from "axios";
import Tab1 from "./Tab1";
import { Typography } from "@mui/material";

const FournisseurPage = () => {
    const auth = useAuthUser();
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()));
    const authHeader = useAuthHeader();
    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true); 
    const [Enrege, setEnrege] = useState(true); 
    const [Annulactv, setAnnule] = useState(true); 
    const [FormAct, setFormactve] = useState(true);
    const [EtatG, setEtatG] = useState(false); 
    const [sbmit, setSbmit] = useState("");

//     const getLabelFromCode = (params: any, targetFieldName: string) => {
//     const config = {
//         method: 'get',
//         url: Data.ApiUrl.AnySearch,
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': authHeader(),
//             'CypherSearch': Crypter.encrypt(JSON.stringify(params))
//         }
//     };

//     axios(config).then((res) => {
//         const response = JSON.parse(Crypter.decrypt(res.data)).Value;
//         if (response.StatutCode === 200) {
//             const data = response.Result.Table || response.Result;
//             if (data && data.length > 0) {
//                 // On injecte le libellé trouvé dans le champ "lib_..."
//                 form.setFieldValue(targetFieldName, data[0][params.Colonne2]);
//             }
//         }
//     }).catch(err => console.error("Erreur résolution libellé:", err));
// };

    // --- PHASE 1 : CONSULTATION ---
    function HandleConsult() {
        const code = form.getFieldValue("CODEFOURNISSEUR");
        if (!code) {
            SweetAlert.fire("Alerte", "Veuillez choisir un code fournisseur.", "warning");
            return;
        }

        setLoading(true);
        axios.get(Data.ApiUrl.ReadFournisseur, {
            headers: {
                'Authorization': authHeader(),
                'CypherSearch':Crypter.encrypt(JSON.stringify(`BYCODE|${code}`))  
            }
        }).then((response) => {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

    //             const decrypted = Crypter.decrypt(response.data);
    // const res = JSON.parse(decrypted).Value;

    // // --- BLOC DE DIAGNOSTIC ---
    // console.log("=== DIAGNOSTIC MAPPING FOURNISSEUR ===");
    // console.log("1. Structure de l'objet Result :", res.Result);

    // // On essaie d'isoler la ligne de données (d)
    // const d = (res.Result && res.Result.Table) ? res.Result.Table[0] : (res.Result[0] || res.Result);

    // if (d) {
    //     console.log("2. Liste exacte des colonnes renvoyées par le SQL :", Object.keys(d));
    //     console.log("3. Valeurs reçues pour cette ligne :", d);
        
    //     // On vérifie spécifiquement les libellés
    //     console.log("4. Vérification Pays :", { code: d.Pays || d.CODEPAYS, libelle: d.LibellePays || d.LIBELL });
    //     console.log("5. Vérification Forme :", { code: d.FormeJuridique || d.FORMEJURIDIQUE, libelle: d.LibelleFormeJuridique || d.LIBELL });
    //     console.log("6. Vérification Client :", { code: d.CodeClientRef, nom: d.NomClientRef || d.NOMCLI });
    // } else {
    //     console.error("ERREUR : Aucune ligne de données trouvée dans res.Result");
    // }
    // console.log("======================================");
    // --- FIN DU BLOC DE DIAGNOSTIC ---

            if (res.StatutCode === 200) {
                const d = (res.Result && res.Result.Table) ? res.Result.Table[0] : (res.Result[0] || res.Result);

                // Application du mapping validé
                if (d) {
                form.setFieldsValue({
                    // CODEFOURNISSEUR: d.CodeFournisseur,
                    // RAISONSOCIALE: d.RaisonSociale,
                    // FORMEJURIDIQUE: d.FormeJuridique,
                    // CODEPAYS: d.Pays,
                    // NUMCONTRIBUABLE: d.NumContribuable,
                    // CONTACT: d.Contact,
                    // STATUTSCREENING: d.StatutScreening,
                    // ESTCLIENT: d.EstClient,
                    // CODECLIENTREF: d.CodeClientRef,
                    // ESTACTIF: d.EstActif,
                    // // Libellés pour les SearInputG 
                    lib_CODEPAYS: d.LibellePays || d.LIBELL,
                    lib_CODECLIENTREF: d.NomClientRef || d.NOMCLI,
                    lib_FORMEJURIDIQUE: d.LibelleFormeJuridique || d.LIBELL,
                    lib_CODEFOURNISSEUR: d.RaisonSociale,

                    CODEFOURNISSEUR: d.CodeFournisseur,
                    RAISONSOCIALE: d.RaisonSociale,
                    FORMEJURIDIQUE: d.FormeJuridique || d.FORMEJURIDIQUE,
                    CODEPAYS: d.Pays || d.CODEPAYS,
                    NUMCONTRIBUABLE: d.NumContribuable,
                    CONTACT: d.Contact,
                    STATUTSCREENING: d.StatutScreening,
                    ESTCLIENT: d.EstClient,
                    CODECLIENTREF: d.CodeClientRef,
                    ESTACTIF: d.EstActif

                    });
                    
                    
        //             if (d.Pays) {
        //     getLabelFromCode({ 
        //         Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", 
        //         colfiltre: 'RUBRIQ', valfiltre: 'PAYS', 
        //         valeurrecherche: d.Pays, Choix: 22 
        //     }, "lib_CODEPAYS");
        // }

        // // Pour la Forme Juridique
        // if (d.FormeJuridique) {
        //     getLabelFromCode({ 
        //         Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", 
        //         colfiltre: 'RUBRIQ', valfiltre: 'FORMEJURIDIQUE', 
        //         valeurrecherche: d.FormeJuridique, Choix: 22 
        //     }, "lib_FORMEJURIDIQUE");
        // }

        // // Pour le Client (si existant)
        // if (d.CodeClientRef) {
        //     getLabelFromCode({ 
        //         Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", 
        //         valeurrecherche: d.CodeClientRef, Choix: 22 
        //     }, "lib_CODECLIENTREF");
        // }
                

                setModife(false);
                setAnnule(false);
                setConsulte(true);
            }

            } else {
                SweetAlert.fire({ title: res.Message, text: res.Result, icon: "info" });
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.error("DÉTAIL ERREUR :", err); 
            SweetAlert.fire("Erreur", "Impossible de joindre le serveur", "error");
        });
    }

    // --- PHASE 3 : CRÉATION ---
    function HandleAjout() {
        form.resetFields();
        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setAnnule(false);
        setEtatG(true); 
        setFormactve(false); 
        setSbmit('add');
    }

    // --- PHASE 2 : MODIFICATION ---
    function HandleModif() {
        setEnrege(false);
        setModife(true);
        setEtatG(true); 
        setFormactve(false);
        setSbmit('modif');
    }

    // --- RÉINITIALISATION ---
    function HandleAnnul() {
        setEtatG(false);
        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setAnnule(true);
        form.resetFields();
        setFormactve(true);
        setSbmit('');
    }

    // --- PHASE 4 : ENGAGEMENT (SAVE/UPDATE) ---
    const onFinish = (values: any) => {
        const isAdd = sbmit === "add";
        const url = isAdd ? Data.ApiUrl.CreateFournisseur : Data.ApiUrl.UpdateFournisseur;

        // payload
        const estClient = values.ESTCLIENT || !!values.CODECLIENTREF;
        const payload = {
            CodeFournisseur: values.CODEFOURNISSEUR,
            RaisonSociale: values.RAISONSOCIALE,
            FormeJuridique: values.FORMEJURIDIQUE,
            Pays: values.CODEPAYS,
            NumContribuable: values.NUMCONTRIBUABLE || null,
            Contact: values.CONTACT || "",
            StatutScreening: values.STATUTSCREENING || "EN_ATTENTE",
            EstClient: estClient,
            CodeClientRef: estClient ? (values.CODECLIENTREF || null) : null,
            EstActif: values.ESTACTIF || false
        };

        SweetAlert.fire({
            title: isAdd ? "Enregistrement" : "Modification",
            text: `Voulez-vous valider la fiche du fournisseur : ${values.RAISONSOCIALE} ?`,
            showCancelButton: true,
            confirmButtonColor: "green",
            cancelButtonColor: "darkred",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            icon: 'question'
        }).then((res) => {
            if (res.isConfirmed) {
                setLoading(true);
                let encryptedData = Crypter.encrypt(JSON.stringify(payload));
                
                const config = {
                    method: isAdd ? 'post' : 'put',
                    url: url,
                    data: encryptedData,
                    headers: { 'Authorization': authHeader(), 'Content-Type': 'application/json' }
                };

                axios(config).then((response) => {
                    setLoading(false);
                    const resJson = JSON.parse(Crypter.decrypt(response.data)).Value;
                    if (resJson.StatutCode === 200) {
                        SweetAlert.fire("Succès", resJson.Message, "success");
                        HandleAnnul();
                    } else {
                        SweetAlert.fire({ title: resJson.Message, text: resJson.Result, icon: "warning" });
                    }
                }).catch((err) => {
                    setLoading(false);
                    console.error(err);
                    SweetAlert.fire("Erreur", "Le serveur a refusé la transaction", "error");
                });
            }
        });
    };

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: <span><TeamOutlined /> Identification Fournisseur</span>,
            children: <Tab1 
                EtatG={EtatG}
                form={form} 
                disabledForm={FormAct}
                sbmit={sbmit}
            />
        }
    ];

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> 
                <b> RÉFÉRENTIEL DES FOURNISSEURS </b> 
            </Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }}>
                <Form 
                    form={form} 
                    onFinish={onFinish} 
                    onFinishFailed={(error) => console.log("Validation échouée :", error)}
                    preserve
                    labelAlign="left"
                >
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' disabled={Consultactv} onClick={HandleConsult} block>Consulter</Button>
                                <Button size='large' disabled={Ajoutactv} onClick={HandleAjout} block>Ajouter</Button>
                                <Button size='large' disabled={Modifactv} onClick={HandleModif} block>Modifier</Button>
                                <Button size='large' disabled={Enrege} htmlType="submit" block>Enregistrer</Button>
                                <Button size='large' disabled={Annulactv} onClick={HandleAnnul} block>Annuler</Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                    </div>
                </Form>
            </Spin>
        </div>
    );
};

export default FournisseurPage;